import { defineFcm } from '../shared/factory';

export const FCM_PRIVACY_REDACT_UNDER_REVIEW_PETITIONS = defineFcm('privacy_redact_under_review_petitions')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'APIs / security / safety',
		description: `Kill switch for redacting under-review petitions in the middle-end API, to protect their starter and supporters.

		When enabled, a petition whose status is "under_review" is redacted for every viewer who can't edit it (anyone but the starter, Staff, Support and the owning organization's admins), and for requests without a session:
		- its title and description return "[REDACTED]"
		- its starter is returned as a fully anonymous user
		- its photo, share visuals and AI summaries are hidden
		- its social starter talking points and angles, which are generated from its text, are hidden
		- its signers and public promoters lists are empty
		- its ready-to-share posts and preview links are unavailable, and its endorsements list is empty
		- decision maker responses to it have their message, photo and media hidden
		- its updates (every kind) are redacted too: title and description return "[REDACTED]", the author is a fully anonymous user, and photo, media and endorsement content are hidden

		It also makes the social share redirects (Facebook, X, WhatsApp) fail for an under-review petition, even for editors: they send the viewer to the homepage with a "sharable_not_found" error instead of the share platform.

		When disabled, nothing is redacted and the API behaves as before.`,
	});
